<template>
  <div class="app">
      <div>
        <search v-if="isSearch" :id="1"></search>
        <!-- 内容区域 -->
        <div v-else>
            <!-- 搜索区域 -->
            <tab-nav></tab-nav>
            <!-- 内容主体 -->
            <home></home>
            <!-- 侧边回顶部nav -->
            <to-top></to-top>
        </div>
      </div>
  </div>
</template>
<script>
import ToTop from './components/global/ToTop.vue'
import Home from './views/Home.vue'
import Search from './views/Search.vue'
export default {
  components: { Home, ToTop, Search },
  data() {
      return {
          isSearch: true, //是否在单独的搜索框页面
      }
  },
  methods: {
	changTab() {
		// let title = this.$global.tabLists.find(v => {if((this.$utils.getUrlQuery(v.title))){return v}})
		let title = this.$global.tabLists.find(v => {if(this.$utils.getUrlQuery('tab') === v.title) {return v}})
		if(title) {
			this.isSearch = false
			this.$global.tab = title
		}else if(this.$utils.getUrlQuery('q')) {
			this.isSearch = false
        }
        // else if (this.$global.q && this.$global.tab != 'picture' && this.$global.tab != 'dealers' && this.$global.tab != 'carQa') {
        //     this.isSearch = false
        // }
	}
  },
  mounted() {
      this.$EventBus.$on('showContent', () => {this.isSearch = false})
      this.$EventBus.$on('closeContent', () => {this.isSearch = true})
      this.changTab()
  },
}
</script>
<style lang="scss">
.app {
  margin: 0;
  padding: 0;
  background-color: #ffffff;
  position: relative;
  font-size: 12px;
  min-width: 1020px;
  .control-height {
      min-height: calc(100vh - 186px);
  }
}
.app a:hover {
    color: #ff6600 !important;
}
</style>